import React from 'react';
import PropTypes from 'prop-types';

const TextArea = (props) => {
    const onChange = (event) => {
        props.onChange(event.target.value);
    };

    return (
        <div className="ui-text-area">
            <textarea
                className="ui-text-area__input"
                maxLength={props.maxLength}
                onChange={onChange}
                value={props.value}
            />
        </div>
    );
};

TextArea.defaultProps = {
    maxLength: null,
};

TextArea.propTypes = {
    maxLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default TextArea;
